import { render, staticRenderFns } from "./BankingLayout.vue?vue&type=template&id=20d331dc&scoped=true&"
import script from "./BankingLayout.vue?vue&type=script&lang=js&"
export * from "./BankingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d331dc",
  null
  
)

export default component.exports